export enum DialogsEnum {
  DIALOG_USERS = 'DIALOG_USERS',
  DIALOG_BRAND = 'DIALOG_BRAND',
  DIALOG_BRAND_FORM = 'DIALOG_BRAND_FORM',
  DIALOG_WAGERING_CONTRIBUTION = 'DIALOG_WAGERING_CONTRIBUTION',
  DIALOG_WAGERING_CONTRIBUTION_FORM = 'DIALOG_WAGERING_CONTRIBUTION_FORM',
  DIALOG_EXCLUDED_GAMES = 'DIALOG_EXCLUDED_GAMES',
  DIALOG_EXCLUDED_GAMES_FORM = 'DIALOG_EXCLUDED_GAMES_FORM',
  DIALOG_EDIT_PLAYER_DATA = 'DIALOG_EDIT_PLAYER_DATA',
  DIALOG_EDIT_ACCOUNT_STATUS = 'DIALOG_EDIT_ACCOUNT_STATUS',
  DIALOG_EDIT_KYC_STATUS = 'DIALOG_EDIT_KYC_STATUS',
  DIALOG_CREATE_RG_EXCLUSION = 'DIALOG_CREATE_RG_EXCLUSION',
  DIALOG_CREATE_RG_COOL_OFF = 'DIALOG_CREATE_RG_COOL_OFF',
  DIALOG_CREATE_RG_LIMITS = 'DIALOG_CREATE_RG_LIMITS',
  DIALOG_MANUAL_DEBIT_CREDIT = 'DIALOG_MANUAL_DEBIT_CREDIT',
  DIALOG_MANUAL_BONUS = 'DIALOG_MANUAL_BONUS',
}
